module.exports = __webpack_public_path__ + "img/1440.7db7257f.jpg";